module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/efficient-text.4c3aa949.png";